import React from "react";
import { useTranslation } from "react-i18next";
import { FooterRow } from "../../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../../UI/Modal";
import FooterForm from "../FooterForm";

type Props = {
  footerRow?: FooterRow;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (data: FooterRow) => void;
};

const FooterRowModal: React.FC<Props> = ({
  footerRow,
  isOpen,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {!footerRow
            ? t("components.common.footerModal.typeNew")
            : t("components.common.footerModal.typeEdit")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <FooterForm
          isSubmitting={isSubmitting}
          onSubmit={(data: any) => onSubmit(data)}
          onCancel={onClose}
          footerRow={footerRow}
        />
      </ModalBody>
    </Modal>
  );
};

export default FooterRowModal;
